import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';

export default class UserLabelApiV4 extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  public create({
    organizationId,
    userLabels,
  }: {
    organizationId: number;
    userLabels: string[];
  }) {
    const query = '/core/v4/label';
    return this.post(query, {
      organization: {
        id: organizationId,
      },
      name: userLabels,
    });
  }

  public list({
    productKeyId,
    organizationId,
  }: {
    productKeyId?: number;
    organizationId?: number;
  }) {
    const query = '/core/v4/label';
    const params: { product_key_id?: number; organization_id?: number } = {};
    if (productKeyId) {
      params.product_key_id = productKeyId;
    }
    if (organizationId) {
      params.organization_id = organizationId;
    }

    return this.get(query, qs.stringify(params, true), true);
  }

  public list_available({
    product_key_ids,
    organization_ids,
  }: {
    product_key_ids?: number[];
    organization_ids?: number[];
  }) {
    const query = '/core/v4/label/list_available';
    const data: { product_key_ids?: number[]; organization_ids?: number[] } =
      {};
    if (product_key_ids) {
      data.product_key_ids = product_key_ids;
    }
    if (organization_ids) {
      data.organization_ids = organization_ids;
    }

    return this.post(query, data);
  }

  public list_attached({ productKey_ids }: { productKey_ids: number[] }) {
    const query = '/core/v4/label/list_attached';
    return this.post(query, { product_key_ids: productKey_ids });
  }

  public update({ labels }: { labels: { name: string; id: number }[] }) {
    const query = '/core/v4/label';
    return this.put(query, { labels });
  }

  public remove({ labelsIds }: { labelsIds: number[] }) {
    const query = '/core/v4/label';
    return this.delete(query, { label_ids: labelsIds });
  }

  public attach({
    links,
  }: {
    links: { product_key_id: number; label_id: number }[];
  }) {
    const query = '/core/v4/label/attach';
    return this.post(query, { to_attach: links });
  }

  public detach({
    links,
  }: {
    links: { product_key_id: number; label_id: number }[];
  }) {
    const query = '/core/v4/label/detach';
    return this.post(query, { to_detach: links });
  }
}
